interface RowsPerPageSelectProps {
  value: number;
  onChange: (value: number) => void;
  options?: number[];
  disabled?: boolean;
  disabledTitle?: string;
}

const DEFAULT_OPTIONS = [25, 50, 100, 200];

/**
 * Standalone rows-per-page selector. Renders independently of the Pagination
 * component so it stays usable when there is only one page (e.g. after the
 * user picks a page size larger than the dataset).
 *
 * @param value - currently selected page size
 * @param onChange - called with the new page size when the user picks one
 * @param options - allowed page sizes; defaults to 25/50/100/200
 * @param disabled - disable interaction (e.g. while pending edits exist)
 * @param disabledTitle - tooltip shown when disabled
 */
export function RowsPerPageSelect({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  disabled = false,
  disabledTitle,
}: RowsPerPageSelectProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <span>Rows:</span>
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        className="h-9 rounded-md border border-input bg-background px-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
        aria-label="Rows per page"
        title={disabled && disabledTitle ? disabledTitle : 'Rows per page'}
      >
        {options.map((n) => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
    </div>
  );
}
